import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import { applySeoMeta, applyNoIndex, getHomeMeta, getArticleMeta } from '@/lib/seo';
import { buildHomeSchema, buildArticleSchema, injectJsonLd, removeJsonLd } from '@/lib/schema';

type Lang = 'pt' | 'de' | 'en';

export default function SeoManager() {
  const homeMatch = useMatch('/');
  const articleMatch = useMatch('/article/:slug');
  const { i18n } = useTranslation();

  const detected = i18n.language || 'pt';
  const lang: Lang = detected === 'de' || detected === 'en' ? detected : 'pt';

  useEffect(() => {
    if (articleMatch) {
      const slug = articleMatch.params.slug as string;
      const article = articles.find((a) => a.slug === slug) || articles[0];
      applySeoMeta(
        getArticleMeta(article.title[lang], article.description[lang], article.slug, article.image),
      );
      injectJsonLd('ld-article', buildArticleSchema(article, lang));
      removeJsonLd('ld-home');
      return;
    }

    if (homeMatch) {
      applySeoMeta(getHomeMeta());
      injectJsonLd('ld-home', buildHomeSchema());
      removeJsonLd('ld-article');
      return;
    }

    // Non-indexable catch-all (404).
    applyNoIndex('Page Not Found');
    removeJsonLd('ld-home');
    removeJsonLd('ld-article');
  }, [homeMatch, articleMatch, lang]);

  return null;
}